var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { calculateDistanceBetweenLatLngs } from "@irati/geolocation/src/helpers/geometry";
/**
 * Finds the index of the card that represents the requested deal UUID
 */
var getCardIndex = function (cards, dealUuid) { return cards.findIndex(function (card) { return card.deal.uuid === dealUuid; }); };
/**
 * Sorts an array of locations by their proximity to a certain location (sorts the array in-place)
 */
var sortLocationsByProximity = function (locations, latLng) {
    locations.sort(function (_a, _b) {
        var latA = _a.lat, lngA = _a.lng;
        var latB = _b.lat, lngB = _b.lng;
        var locationADistFromUser = calculateDistanceBetweenLatLngs({ lat: latA, lng: lngA }, latLng);
        var locationBDistFromUser = calculateDistanceBetweenLatLngs({ lat: latB, lng: lngB }, latLng);
        return locationADistFromUser < locationBDistFromUser ? -1 : 1;
    });
};
/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for the Cards
 */
// @todo: Create a deal interface
var prepareMapCards = function (deals, userLatLng, mapCenterLatLng) {
    var hash = new Map();
    deals.map(function (deal) {
        var uuid = deal.uuid, location = deal.location;
        var data = hash.get(uuid) || { deal: deal, locations: [] };
        data.locations.push(location);
        hash.set(uuid, data);
    });
    return Array.from(hash)
        .map(function (_a) {
        var dealUuid = _a[0], _b = _a[1], deal = _b.deal, locations = _b.locations;
        var mapCenterProximity = 0;
        if (mapCenterLatLng) {
            sortLocationsByProximity(locations, mapCenterLatLng);
            mapCenterProximity = calculateDistanceBetweenLatLngs(locations[0], mapCenterLatLng);
        }
        var proximityMeters = 0;
        if (userLatLng) {
            sortLocationsByProximity(locations, userLatLng);
            proximityMeters = calculateDistanceBetweenLatLngs(locations[0], userLatLng);
        }
        return {
            key: dealUuid,
            proximityMeters: proximityMeters,
            mapCenterProximity: mapCenterProximity,
            deal: deal,
            locations: locations
        };
    })
        .sort(function (a, b) { return (a.mapCenterProximity < b.mapCenterProximity ? -1 : 1); })
        .map(function (deal, index) {
        return __assign(__assign({}, deal), { number: index + 1 });
    });
};
/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for the Map
 */
// @todo: Create a deal interface
var prepareMapLocations = function (deals, cards) {
    return deals.map(function (deal) {
        var location = deal.location, dealUuid = deal.uuid;
        var lat = location.lat, lng = location.lng, locationUuid = location.uuid;
        var index = getCardIndex(cards, dealUuid);
        return {
            key: locationUuid,
            lat: lat,
            lng: lng,
            index: index,
            number: index + 1,
            isActive: false,
            showDetails: false,
            zIndex: 1,
            deal: deal
        };
    });
};
export var convertBoundingBoxStringToBoundingBox = function (boundingBoxString) {
    var arr = boundingBoxString ? boundingBoxString.split(",") : [];
    return arr.map(function (item) { return parseFloat(item); });
};
/**
 * Formats the deals data into a format that can be used by the searchAllByLocation page for both Cards and the Map locations
 */
// @todo: Create a deal interface
export var prepareMapCardsAndLocations = function (deals, userLatLng, mapCenterLatLng) {
    var cards = prepareMapCards(deals, userLatLng, mapCenterLatLng);
    var locations = prepareMapLocations(deals, cards);
    return {
        cards: cards,
        locations: locations
    };
};
